// Default 2026 IT Goals Structure
export const DEFAULT_TOPICS = [
  {
    id: 'device-identity',
    name: 'Strengthen Device and Identity Management',
    description: 'Focus on creating a predictable, secure, and low-friction environment for our fully remote workforce.',
    color: '#3B82F6',
    lead: 'Corey/Will',
    dueDate: '2026-12-31',
    initiatives: [
      { id: 'di-1', title: 'Standardize device build automation (onboarding/offboarding in minutes)', status: 'not_started', phase: 'Phase 1', dueDate: '2026-03-31', notes: '' },
      { id: 'di-2', title: 'Refine MDM/endpoint management - encryption, patching, compliance', status: 'not_started', phase: 'Phase 1', dueDate: '2026-03-31', notes: '' },
      { id: 'di-3', title: 'Implement zero-touch provisioning for all hardware', status: 'not_started', phase: 'Phase 2', dueDate: '2026-06-30', notes: '' },
      { id: 'di-4', title: 'Publish quarterly endpoint health dashboard', status: 'not_started', phase: 'Phase 2', dueDate: '2026-06-30', notes: '' },
      { id: 'di-5', title: 'Create visual IT footprint (devices by region)', status: 'not_started', phase: 'Phase 2', dueDate: '2026-09-30', notes: '' },
      { id: 'di-6', title: 'Build single-pane support portal (login, notifications, docs, support)', status: 'not_started', phase: 'Phase 3', dueDate: '2026-12-31', notes: '' },
    ]
  },
  {
    id: 'clinical-tech',
    name: 'Build a Cohesive Clinical Technology Experience',
    description: 'Map clinician workflows and streamline tools for better patient care.',
    color: '#10B981',
    lead: 'Tim/Dan',
    dueDate: '2026-12-31',
    initiatives: [
      { id: 'ct-1', title: 'Map end-to-end clinician workflow across therapy settings', status: 'not_started', phase: 'Phase 1', dueDate: '2026-03-31', notes: '' },
      { id: 'ct-2', title: 'Develop unified clinical portal (login, notifications, docs, support)', status: 'not_started', phase: 'Phase 2', dueDate: '2026-06-30', notes: '' },
      { id: 'ct-3', title: 'Improve offline-friendly workflows for unstable connectivity', status: 'not_started', phase: 'Phase 2', dueDate: '2026-09-30', notes: '' },
      { id: 'ct-4', title: 'Create pre-flight micro-app (user/device/network readiness check)', status: 'not_started', phase: 'Phase 3', dueDate: '2026-12-31', notes: '' },
    ]
  },
  {
    id: 'automation',
    name: 'Deep Automation and a "No-Ops" Mindset',
    description: 'Expand automation so the team can focus on strategic work instead of routine tasks.',
    color: '#8B5CF6',
    lead: 'Will/Craig',
    dueDate: '2026-12-31',
    initiatives: [
      { id: 'au-1', title: 'Automated account provisioning/deprovisioning tied to HRIS', status: 'not_started', phase: 'Phase 1', dueDate: '2026-03-31', notes: '' },
      { id: 'au-2', title: 'Self-service portal with scripted fixes (VPN, printers, credentials)', status: 'not_started', phase: 'Phase 1', dueDate: '2026-06-30', notes: '' },
      { id: 'au-3', title: 'Real-time dashboards (performance, compliance, facility health)', status: 'not_started', phase: 'Phase 2', dueDate: '2026-09-30', notes: '' },
      { id: 'au-4', title: 'Push-alert system for major outages (TMC Connect)', status: 'not_started', phase: 'Phase 2', dueDate: '2026-12-31', notes: '' },
    ]
  },
  {
    id: 'human-side',
    name: 'Level Up the Human Side of IT',
    description: 'Improve how the team learns, collaborates, and supports the organization.',
    color: '#F59E0B',
    lead: 'Devon/Craig',
    dueDate: '2026-12-31',
    initiatives: [
      { id: 'hs-1', title: 'Rebuild internal documentation (80% daily issues resolvable by any team member)', status: 'not_started', phase: 'Phase 1', dueDate: '2026-03-31', notes: '' },
      { id: 'hs-2', title: 'Create training path for junior engineers to senior roles', status: 'not_started', phase: 'Phase 1', dueDate: '2026-06-30', notes: '' },
      { id: 'hs-3', title: 'Build interactive knowledge base with troubleshooting walkthroughs', status: 'not_started', phase: 'Phase 2', dueDate: '2026-09-30', notes: '' },
      { id: 'hs-4', title: 'Develop TMC Connect application', status: 'not_started', phase: 'Phase 2', dueDate: '2026-09-30', notes: '' },
      { id: 'hs-5', title: 'Create fully featured Support front end + mobile app', status: 'not_started', phase: 'Phase 3', dueDate: '2026-12-31', notes: '' },
    ]
  },
  {
    id: 'ai-assistance',
    name: 'AI and Intelligent Assistance',
    description: 'Embed intelligent automation directly into our tools and workflows.',
    color: '#EC4899',
    lead: 'Corey/Tim/Dan',
    dueDate: '2026-12-31',
    initiatives: [
      { id: 'ai-1', title: 'Integrate LLM-based assistance into internal apps', status: 'not_started', phase: 'Phase 1', dueDate: '2026-03-31', notes: '' },
      { id: 'ai-2', title: 'AI-powered site intake tool (natural language, auto-diagnostics)', status: 'not_started', phase: 'Phase 2', dueDate: '2026-06-30', notes: '' },
      { id: 'ai-3', title: 'Extend Copilot capabilities to daily IT and clinical operations', status: 'not_started', phase: 'Phase 2', dueDate: '2026-09-30', notes: '' },
      { id: 'ai-4', title: 'AI analysis of logs, tickets, audit trails, compliance data', status: 'not_started', phase: 'Phase 3', dueDate: '2026-12-31', notes: '' },
      { id: 'ai-5', title: 'AI video mascot for training delivery', status: 'not_started', phase: 'Phase 3', dueDate: '2026-12-31', notes: '' },
    ]
  },
  {
    id: 'profit-center',
    name: 'Position IT as a Profit Center',
    description: 'Turn IT capabilities into revenue-generating offerings through EverWatch Technologies.',
    color: '#06B6D4',
    lead: 'Everyone',
    dueDate: '2026-12-31',
    initiatives: [
      { id: 'pc-1', title: 'Formalize branding, naming, and marketing materials', status: 'not_started', phase: 'Phase 1', dueDate: '2026-03-31', notes: '' },
      { id: 'pc-2', title: 'Establish clear growth targets for contract expansion', status: 'not_started', phase: 'Phase 1', dueDate: '2026-06-30', notes: '' },
      { id: 'pc-3', title: 'Create EverWatch marketing materials', status: 'not_started', phase: 'Phase 2', dueDate: '2026-09-30', notes: '' },
      { id: 'pc-4', title: 'Build external support service dashboard', status: 'not_started', phase: 'Phase 2', dueDate: '2026-12-31', notes: '' },
    ]
  }
];
